module.exports = __webpack_public_path__ + "static/media/Inspectionpast.23981622.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Inspectionpast.PNG
// module id = 2303
// module chunks = 0